import React, { useState, useEffect } from "react";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Button from "@material-ui/core/Button";
import SaveIcon from "@material-ui/icons/Save";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";
import { useHistory, useParams } from "react-router-dom";
import { Loading } from "../atoms";
import { isEmpty } from "lodash";
import { obternerRegistroxID, actualizarRegistro } from "../utils/Actions";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import IconButton from "@material-ui/core/IconButton";
const initialstate = {
  name: "",
  address: "",
  contactname: "",
  contactphone: "",
  contactemail: "",
  createAt: new Date(),
  status: true,
  user: "",
  desactivedescription: "",
};

export default function EditCustomer() {
  const [state, setstate] = useState(initialstate);
  const [visible, setVisible] = useState(false);
  const account = JSON.parse(localStorage.getItem("Account"));
  const history = useHistory();

  let { id } = useParams();
  const idcustomer = id.slice(4);

  useEffect(() => {
    (async () => {
      setVisible(true);
      console.log("AQUÍ ESTÁ EL RESULTADO");
      console.log(idcustomer);
      const { data } = await obternerRegistroxID("Accounts", idcustomer);
      console.log(data);
      setstate({ ...state, ...data });
      setVisible(false);
    })();
  }, []);

  const save = async () => {
    const {
      name,
      address,
      contactname,
      contactphone,
      contactemail,
      createAt,
      status,
      user,
      desactivedescription,
    } = state;

    if (isEmpty(name)) {
      alert("Favor introduzca el nombre de la propiedad");
    } else if (isEmpty(contactname)) {
      alert("Favor introduzca el nombre del contácto de referencia");
    } else if (isEmpty(contactphone)) {
      alert("Favor introduzca el número de teléfono del contácto");
    } else {
      setVisible(true);
      const accountreg = {
        ...state,
        userupdated: `${account[0].name} ${account[0].lastname}`,
        updatedAt: new Date(),
        desactivedescription: status ? "" : desactivedescription,
      };
      const { statusresponse } = await actualizarRegistro(
        "Accounts",
        idcustomer,
        accountreg
      );
      if (statusresponse) {
        alert("Actualización éxitosa");
      } else {
        alert("Actualización fallida, favor inténtelo nuevamente");
      }
      setVisible(false);
      history.push("/customers");
    }
  };

  const onChange = (e) =>
    setstate({ ...state, [e.target.name]: e.target.value });

  return (
    <FormControl
      style={{
        backgroundColor: "#fff",
        borderRadius: 5,
        padding: 20,
        paddingBottom: 30,
      }}
    >
      <Typography gutterBottom variant="h5">
        <IconButton>
          <ChevronLeftIcon onClick={() => history.goBack()} />
        </IconButton>
        Editar Cuenta
      </Typography>

      <Grid container spacing={5}>
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Nombre de la propiedad"
            variant="outlined"
            fullWidth
            name="name"
            onChange={onChange}
            value={state.name}
            onSubmit={() => {
              console.log("salio");
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="outlined-basic"
            label="Nombre del contácto"
            variant="outlined"
            fullWidth
            name="contactname"
            onChange={onChange}
            value={state.contactname}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Correo del contácto"
            variant="outlined"
            fullWidth
            name="contactemail"
            onChange={onChange}
            value={state.contactemail}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="outlined-basic"
            label="Teléfono"
            variant="outlined"
            fullWidth
            name="contactphone"
            onChange={onChange}
            value={state.contactphone}
          />
        </Grid>

        <Grid item xs={10}>
          <TextField
            id="outlined-basic"
            label="Dirección"
            variant="outlined"
            fullWidth
            name="address"
            onChange={onChange}
            value={state.address}
          />
        </Grid>
        <Grid item xs={2}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                onChange={(e) => {
                  setstate({ ...state, status: e.target.checked });
                }}
                checked={Boolean(state.status)}
              />
            }
            label="Estatus"
            labelPlacement="start"
            value={state.status}
          />
        </Grid>
        {Boolean(state.status) === false && (
          <Grid item xs={10}>
            <TextField
              id="outlined-basic"
              label="Justificación de desactivación"
              variant="outlined"
              fullWidth
              name="desactivedescription"
              onChange={onChange}
              value={state.desactivedescription}
            />
          </Grid>
        )}

        <Grid
          item
          xs={12}
          direction="row"
          justify="center"
          alignItems="center"
          container
        >
          <Button
            size="large"
            variant="contained"
            color="secondary"
            startIcon={<SaveIcon />}
            onClick={save}
          >
            GUARDAR
          </Button>
        </Grid>
      </Grid>
      <Loading visible={visible} setVisible={setVisible} />
    </FormControl>
  );
}
